import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition
} from "@atlaskit/modal-dialog";
import { Banner, Button, Icon } from "@quantumcast/ui";
import { useMachine } from "@xstate/react";
import React from "react";
import { t } from "../../../../../global/Localization/translation";
import ConfigContext from "../../../../Config/ConfigContext";
import { Playlist } from "../../../domain";
import PlaylistsContext from "../../../PlaylistsContext";
import { PlaylistRuleRestriction } from "../../../types";
import PlaylistRestriction from "../PlaylistRestriction/PlaylistRestriction";
import "./AddPlaylistRestriction.scss";
import { addPlaylistRestrictionMachine } from "./addPlaylistRestrictionMachine";

type Props = {
  playlist: Playlist;
};

const AddPlaylistRestriction = (props: Props) => {
  const config = React.useContext(ConfigContext);
  const playlists = React.useContext(PlaylistsContext);
  const [state, sendEvent] = useMachine(addPlaylistRestrictionMachine, {
    context: {
      restriction: {},
    },
    services: {
      addPlaylistRestriction: (context) => {
        const newRestrictions = [
          ...props.playlist.rules.restrictions,
          context.restriction as PlaylistRuleRestriction,
        ];
        return playlists.onSave(props.playlist.id, {
          rules: {
            ...props.playlist.rules,
            restrictions: newRestrictions,
          },
        });
      },
    },
  });

  const onChange = (item: Partial<PlaylistRuleRestriction>) => {
    sendEvent({ type: "CHANGE", restriction: item });
  };

  return (
    <div className="add-playlist-restriction">
      <Button
        onClick={() => sendEvent("OPEN")}
        appearance="link"
        iconBefore={
          <Icon.IonIcons5.IoAdd title={t("file.cues.delete")} size={15} />
        }
      >
        {t("playlist.settings.rules.restriction.add")}
      </Button>
      <ModalTransition>
        {state.matches("MODAL_OPEN") && (
          <Modal onClose={() => sendEvent("CLOSE")}>
            <ModalHeader>
              <ModalTitle>
                {t("playlist.settings.rules.restriction.add")}
              </ModalTitle>
            </ModalHeader>
            <ModalBody>
              {state.context.error && (
                <div className="delete-playlist__error">
                  <Banner appearance="error">{t(state.context.error)}</Banner>
                </div>
              )}
              <PlaylistRestriction
                type="add"
                restriction={state.context.restriction}
                metaDataKeys={config.metaDataKeys}
                onChange={onChange}
              />
            </ModalBody>
            <ModalFooter>
              <Button
                appearance="secondary"
                onClick={() => sendEvent("CLOSE")}
                type="reset"
              >
                {t("action.cancel")}
              </Button>
              <Button
                type="submit"
                appearance="primary"
                onClick={() => sendEvent({ type: "SUBMIT" })}
                isLoading={state.matches("MODAL_OPEN.PROCESSING")}
                isDisabled={!state.can("SUBMIT")}
              >
                {t("action.save")}
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
    </div>
  );
};

export default AddPlaylistRestriction;
